import React, { lazy, Suspense } from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import { ThemeProvider } from '../components/ThemeContext'
// import Navbar from './Navbar'
import { Footer } from './Footer'
import { DynamicBrowserTabTitle } from './DynamicBrowserTabTitle'
// import NavbarSideRight from './navigation/side/right/NavbarSide'
// import CookieConsent, { Cookies } from 'react-cookie-consent'
import './all.sass'
const Navbar = lazy(() => import('./Navbar'))
const NavbarSideRight = lazy(() => import('./navigation/side/right/NavbarSide'))
const renderLoader = () => <p>Loading...</p>
// const IOSWrap = styled.div`
//   padding-top: env(safe-area-inset-top);
//   padding-left: env(safe-area-inset-left);
//   padding-right: env(safe-area-inset-right);
//   padding-bottom: env(safe-area-inset-bottom);
// `

const Layout = ({ footerData = null, browserTab = null, children }) => {
  // const [isMobile, setIsMobile] = useState(false)
  const isSSR = typeof window === 'undefined'
  // useEffect(() => {
  //   setTimeout(function () {
  //     if (window.innerWidth < 720) {
  //       setIsMobile(true)
  //       console.log('is mobile')
  //     } else {
  //       setIsMobile(false)
  //       console.log('is screen')
  //     }
  //   }, 2000);
  //
  //   // axios.post("/.netlify/functions/analytics", {
  //   //   isMobile
  //   // }).then((response) => {
  //   //
  //   //   // console.log('success', response)
  //   //   return {
  //   //     statusCode: 200,
  //   //     body: JSON.stringify(response)
  //   //   }
  //   // }).catch((error) => {
  //   //   // console.log('error', error)
  //   //   return {
  //   //     statusCode: 400,
  //   //     body: JSON.stringify(error)
  //   //   }
  //   // })
  // }, [])

  // useEffect(() => {
  //   setTimeout(function () {
  //     let isMobile = false
  //     // alert(isMobile)
  //     if (window.innerWidth < 720) {
  //       // setIsMobile(true)
  //       isMobile = true
  //       console.log('is mobile')
  //     } else {
  //       // setIsMobile(false)
  //       isMobile = false
  //       console.log('is screen')
  //     }
  //
  //     console.log(isMobile)
  //
  //     axios.post("/.netlify/functions/analytics", {
  //       isMobile
  //     }).then((response) => {
  //
  //       // console.log('success', response)
  //       return {
  //         statusCode: 200,
  //         body: JSON.stringify(response)
  //       }
  //     }).catch((error) => {
  //       // console.log('error', error)
  //       return {
  //         statusCode: 400,
  //         body: JSON.stringify(error)
  //       }
  //     })
  //   }, 3000)
  // }, [])

  // function handleAnalytics () {
  //   // alert('geht')
  //   axios.post("/.netlify/functions/analytics", {
  //     isMobile
  //   }).then((response) => {
  //
  //     // console.log('success', response)
  //     return {
  //       statusCode: 200,
  //       body: JSON.stringify(response)
  //     }
  //   }).catch((error) => {
  //     // console.log('error', error)
  //     return {
  //       statusCode: 400,
  //       body: JSON.stringify(error)
  //     }
  //   })
  // }

  // // create an event listener
  // useEffect(() => {
  //   window.addEventListener("resize", handleResize)
  // })

  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              siteTitle
              siteDescription
            }
          }
        }
      `}
      render={data => (
        <>
          <ThemeProvider>
            <DynamicBrowserTabTitle data={browserTab} />

            {/* <CookieConsent
              enableDeclineButton
              location='top'
              buttonText='OK'
              declineButtonText='Ablehnen'
              cookieName='sv-app'
              style={{ background: '#000000', zIndex: '200000', padding: '1rem' }}
              buttonStyle={{ color: 'white', backgroundColor: '#19931f', fontSize: '13px' }}
              declineButtonStyle={{ color: '#fff', backgroundColor: '#19931f', fontSize: '13px' }}
              expires={150}
              onAccept={() => {
                Cookies.set('sv-app', true)
              }}
              onDecline={() => {
                Cookies.remove('sv-app')
              }}
            >
              <span role='img' aria-label='Cookie'>🍪{' '}</span>
              Wir nutzen Cookies und Local Storage Technologie um Ihnen das beste Nutzererlebnis zu ermöglich!
              <span role='img' aria-label='Cookie'>{' '}🍪🍪🍪{' '}</span>
              <Link to='/datenschutz' className='has-text-primary'>Datenschutz</Link>
            </CookieConsent> */}


            {/* <Headroom
              style={{
                zIndex: 2000,
                boxShadow: '1px 1px 1px rgba(0,0,0,0.25)'
              }}
            > */}
              {!isSSR && (
                  <Suspense fallback={renderLoader()}>
                  <Navbar />
                  </Suspense>
              )}

              {/* <div id='top' /> */}
            {/* </Headroom> */}

            {children}

            <Footer data={footerData} />
      
            {!isSSR && (
              <Suspense fallback={renderLoader()}>
                  <NavbarSideRight />
              </Suspense>
            )}
          </ThemeProvider>
        </>
      )}
    />
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export const query = graphql`
  fragment LayoutFragment on Query {
    footerData: allMarkdownRemark(filter: { frontmatter: { templateKey: { eq: "footer" } } }) {
      edges {
        node {
          id
          frontmatter {
            mainpitch {
              logo {
                childImageSharp {
                  gatsbyImageData(
                    width: 150
                    placeholder: BLURRED
                    formats: [AUTO, WEBP]
                  )
                }
              }
              title
              subtitle
              facebook
              copyright
              telefon
            }
          }
        }
      }
    }
    browserTab: allMarkdownRemark(filter: { frontmatter: { templateKey: { eq: "browsertab" } } }) {
      edges {
        node {
          id
          frontmatter {
            tab {
              inactive
              active
            }
          }
        }
      }
    }
  }
`

export default Layout
